<template>
  <b-modal
    id="details_antecipation"
    title="Vendas da Antecipação"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
    size="xl"
    @show="openModal"
  >
    <div v-if="!loading">
      <div class="row">
        <div class="col-12">
          <!-- Anticipation Amount -->
          <p>
            Venda de uma Antecipação no Valor de:
            {{ formatMoney(antecipation.amount) }}
          </p>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              :items="sales"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
              sort-icon-left
            >
              <!-- Creation Date -->
              <template v-slot:cell(created_at)="data">
                {{ data.value | datetime }}
              </template>
              <!-- Type -->
              <template v-slot:cell(type)="data">
                {{ data.value === 'TRANSACTION' ? 'Valor único' : 'Assinatura' }}
              </template>
              <!-- Status -->
              <template v-slot:cell(status)="data">
                <b-badge v-if="data.value === 'unpaid'" variant="secondary">
                  Não pago
                </b-badge>
                <b-badge v-if="data.value === 'paid'" variant="success">
                  Pago
                </b-badge>
                <b-badge v-if="data.value === 'processing' || data.value === 'waiting_payment'"
                  variant="secondary"
                >
                  Processando
                </b-badge>
                <b-badge v-if="data.value === 'refused' || data.value === 'reject'"
                  variant="danger"
                >
                  Recusada
                </b-badge>
                <b-badge v-if="data.value === 'refunded'" variant="warning">
                  Reembolsado
                </b-badge>
                <b-badge v-if="data.value === 'chargedback'" variant="dark">
                  Charged Back
                </b-badge>
                <b-badge v-if="data.value === 'trialing'" variant="info">
                  Avaliação
                </b-badge>
              </template>
              <!-- Total -->
              <template v-slot:cell(total)="data">
                <template v-if="data.item.base_currency">
                  {{ data.item.base_currency.currency_symbol }}
                </template>
                {{ formatMoney(data.item.status === 'paid' ? data.value : 0) }}
              </template>
              <!-- Balance -->
              <template v-slot:cell(balance)="data">
                <template v-if="data.item.base_currency">
                  {{ data.item.base_currency.currency_symbol }}
                </template>
                {{ formatMoney(data.value ? data.value : 0) }}
              </template>
              <!-- Method -->
              <template v-slot:cell(method)="data">
                <PaymentMethodIcon :method="data.value" />
              </template>
              <!-- Score -->
              <template v-slot:cell(_score)="data">
                <NewProgressBar v-if="data.item.risk_score" :type="'SellerScore'" :valor="data.item.risk_score"/>

              </template>
            </b-table>
            <!-- Feedback Menssage -->
            <div v-if="!sales.length">
              <p>Nenhum dado disponivel</p>
            </div>
          </div>
          <!-- Fetch More Sales -->
          <b-button v-if="currentPage !== lastPage" 
            variant="primary"
            class="mr-2" 
            @click="fetchMoreSales"
          >
            Buscar Mais Vendas
          </b-button>
        </div>
      </div>
    </div>
    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Money from '@src/mixins/money'
import Graph from '@router/views/analysis/graph.vue'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'

import AntecipationService from '@services/resources/AntecipationService'
const service = AntecipationService.build()

export default {
  name: "ModalAntecipacao",
  components: { Graph, NewProgressBar },
  mixins: [Money],
  props: {
    antecipation: {
      required: true,
      type: Object,
      default: () => ({
        id: null,
        amount: 0
      })
    }
  },
  data() {
    return {
      currentPage: 1,
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: 'type', label: 'Tipo', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'total', label: 'Valor Greenn', sortable: true },
        { key: 'balance', label: 'Valor distribuído', sortable: true },
        { key: 'method', label: 'Método', sortable: false },
        { key: '_score', label: 'Score', sortable: false },
      ],
      filterOn: [],
      lastPage: 1,
      loading: false,
      sales: [],
      sortBy: 'name',
      sortDesc: false
    }
  },
  methods: {
    /**
     * Fires when user presses the "fetch more sales" button. Makes a request seeking more sales data related to the selected anticipation
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    fetchMoreSales() {
      let page = this.currentPage + 1;
      this.loading = true;

      service
        .read(this.antecipation.id + '/sales?page=' + page)
        .then((resp) => {
          let result = resp.data
          let all = this.sales
          this.sales = all.concat(result);
          this.currentPage = resp.current_page;
          this.lastPage = resp.last_page;
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
    /**
     * Fires when the modal is opened. Makes a request to bring up sales related to the selected anticipation
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    openModal() {
      this.loading = true

      service
        .read(this.antecipation.id + '/sales')
        .then(resp => {
          this.sales = resp.data
          this.currentPage = resp.current_page
          this.lastPage = resp.last_page;
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style scoped lang="scss">
.grid-json {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}
@media (max-width: 768px) {
  .grid-json {
    grid-template-columns: 1fr;
  }
}
.item-grid {
  max-height: 550px;
  overflow: auto;
}
.item-grid::-webkit-scrollbar {
  width: 12px;
}

.item-grid::-webkit-scrollbar-track {
  background: #f7f7f7;
}

.item-grid::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
  border: 3px solid #f7f7f7;
}
.img-produto {
  max-width: 220px;
}
</style>